import { render } from "./StreamSidebarOptionTabs.vue?vue&type=template&id=61f3b931"
import script from "./StreamSidebarOptionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamSidebarOptionTabs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/StreamSidebarOptionTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61f3b931"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61f3b931', __exports__)) {
    api.reload('61f3b931', __exports__)
  }
  
  module.hot.accept("./StreamSidebarOptionTabs.vue?vue&type=template&id=61f3b931", () => {
    api.rerender('61f3b931', render)
  })

}


export default __exports__